import _slicedToArray from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import './index.css';
import * as React from 'react';
import React__default, { useState, useEffect } from 'react';
import interpolateWithComponents from '@clearscore-group/lib.helpers.interpolate-with-components';
import Text from '@clearscore/ui.rainbow.drivescore.text';
import useLanguage from '@clearscore-group/lib.hooks.use-language';
import { EN_GB, GB } from '@clearscore-group/lib.config.i18n';
import cx from 'classnames';
import BurgerIcon from '@clearscore/rainbow.icons.menu-hamburger';
import Drawer from '@clearscore/ui.rainbow.drawer';
import canUseDom from '@clearscore-group/lib.helpers.can-use-dom';
import useMedia from '@clearscore-group/lib.hooks.use-media';
import { mediaQuery } from '@clearscore/ui.rainbow.drivescore.tokens';
var styles$1 = {
  "footerSection": "footerSection--779J4",
  "dsLogo": "dsLogo--w327A",
  "bodyWrapper": "bodyWrapper--M1NsF",
  "body": "body--mtXrK",
  "heart": "heart--spwoP",
  "address": "address--pDMCU",
  "addressTitle": "addressTitle--NHkTZ",
  "links": "links--6BgQ-",
  "copyright": "copyright--6VYnn"
};
var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var SvgDsLogo = function SvgDsLogo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 180 23",
    fill: "currentcolor",
    preserveAspectRatio: "xMidYMid",
    "data-qa": "svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1942 10.8712C30.1942 7.76097 30.2119 4.65076 30.1825 1.54055C30.1766 0.793638 30.2708 0.32098 31.2078 0.361827C34.2721 0.501874 37.3482 0.437686 40.3948 0.72945C45.4333 1.21961 48.9808 5.05339 49.2813 10.0426C49.6585 16.298 46.0343 20.6861 39.7113 21.3513C36.8709 21.6489 33.9834 21.5206 31.1135 21.5964C30.2532 21.6198 30.153 21.1238 30.1589 20.4352C30.1766 17.2433 30.1707 14.0572 30.1707 10.8653C30.1825 10.8712 30.1883 10.8712 30.1942 10.8712ZM34.5078 10.9937C34.5137 10.9937 34.5196 10.9937 34.5255 10.9937C34.5255 12.8668 34.5609 14.7458 34.5078 16.6189C34.4843 17.4709 34.7966 17.7801 35.6275 17.7276C36.7177 17.6634 37.8137 17.7043 38.898 17.5934C42.092 17.2666 43.9718 15.7086 44.4904 12.5751C44.7261 11.1746 44.5375 9.63993 44.2134 8.23362C43.7361 6.14459 42.1745 4.90751 40.0884 4.50488C38.7154 4.24229 37.2775 4.30064 35.8809 4.15476C34.8319 4.04973 34.4371 4.39401 34.4843 5.47937C34.5668 7.32332 34.5078 9.16143 34.5078 10.9937Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.441 15.8837C106.578 16.4498 107.532 17.1383 108.599 17.3951C109.978 17.7277 111.445 17.8211 112.871 17.8211C113.991 17.8211 114.769 17.0741 114.922 15.9654C115.075 14.8392 114.356 14.174 113.349 13.8472C111.74 13.3279 110.108 12.8844 108.493 12.3709C105.688 11.4781 104.191 9.38324 104.197 6.41892C104.203 3.77554 105.871 1.54646 108.493 0.659497C111.934 -0.507559 115.164 -0.0407369 118.222 1.85573C119.041 2.3634 119.436 2.84773 118.617 3.71718C118.051 4.31822 117.733 5.3744 117.079 5.60198C116.566 5.78287 115.724 4.9776 115.011 4.65083C113.62 4.01478 112.176 3.6705 110.656 4.13149C109.766 4.39991 109.035 4.83756 108.959 5.89958C108.882 7.00245 109.33 7.7552 110.396 8.10532C112.27 8.71802 114.174 9.26654 116.03 9.93176C118.505 10.8187 119.56 12.7152 119.589 15.2185C119.613 17.7569 118.54 19.77 116.177 20.8087C112.076 22.6118 108.069 22.1158 104.232 19.9043C103.455 19.4549 103.231 18.9706 103.849 18.1945C104.427 17.4651 104.898 16.6773 105.441 15.8837Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0503 12.0615C22.0208 17.5117 17.9252 21.9582 12.215 22.7342C7.2709 23.4111 1.99676 20.0092 0.499965 15.1776C-0.873079 10.7602 0.641394 6.10953 4.31267 3.30859C4.95499 2.81843 5.34981 2.80676 5.73285 3.5245C5.84482 3.73457 6.00982 3.91546 6.14535 4.11386C7.25322 5.82944 7.25322 5.82944 5.88017 7.33494C3.98266 9.41813 3.60552 12.4291 4.90785 15.02C6.16303 17.5175 9.02698 18.9938 11.9734 18.6787C14.525 18.4045 17.1651 16.2454 17.7308 13.6662C18.3142 11.017 17.7661 8.56035 15.5681 6.73391C14.8256 6.11537 14.7549 5.63687 15.3736 4.97165C15.4797 4.85494 15.5622 4.7149 15.6506 4.58069C17.0236 2.49166 17.0354 2.47998 18.8092 4.2189C21.0131 6.37795 22.0562 9.0155 22.0503 12.0615Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.021 15.3118C170.097 16.8582 171.105 18.2061 172.602 18.282C173.798 18.3403 175.13 18.1653 176.185 17.6576C177.145 17.1966 177.67 17.185 178.336 17.9494C178.725 18.3929 179.261 18.7138 179.732 19.0873C178.789 20.4819 177.593 21.0888 176.314 21.4039C173.468 22.0983 170.628 22.2733 168.135 20.3127C165.766 18.4512 165.348 15.9012 165.513 13.1119C165.796 8.33867 170.227 5.36268 175.395 6.6231C177.953 7.24747 179.373 9.05057 179.75 11.6356C180.274 15.2301 180.28 15.2301 176.644 15.2126C174.505 15.2068 172.366 15.2068 170.227 15.2068C170.186 15.2126 170.15 15.2476 170.021 15.3118ZM175.413 12.1433C175.419 10.5211 174.658 9.68078 173.173 9.58742C171.518 9.48239 170.321 10.4802 170.162 12.1433C171.912 12.1433 173.663 12.1433 175.413 12.1433Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144.434 21.8006C139.902 22.0399 136.614 18.6379 136.649 13.9288C136.685 9.44732 140.091 6.1854 144.793 6.37213C149.36 6.55302 152.407 9.61655 152.366 14.349C152.336 18.2761 149.396 22.1332 144.434 21.8006ZM141.069 14.4307C141.081 14.5707 141.081 15.0492 141.157 15.5219C141.364 16.8348 142.436 17.8501 143.815 18.0719C145.607 18.3578 146.791 17.8443 147.492 16.4905C148.235 15.0609 148.317 13.6137 147.704 12.1199C147.133 10.7253 146.178 10.0484 144.658 10.0192C142.318 9.9725 141.045 11.4138 141.069 14.4307Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.991 19.6415C99.8894 20.2251 98.8523 21.042 97.6737 21.3571C94.6624 22.1624 91.6983 22.1974 89.129 19.9683C86.7365 17.891 86.3475 13.8588 87.3375 11.087C88.4277 8.04101 90.9852 6.49466 94.3501 6.40713C97.273 6.33127 99.5653 7.34661 100.644 10.0892C101.162 11.4196 101.18 12.9601 101.298 14.4131C101.363 15.2184 100.62 15.1542 100.06 15.1542C97.3967 15.16 94.7272 15.16 92.0636 15.16C91.8279 15.16 91.5981 15.1834 91.3683 15.1951C91.3565 16.6656 92.1992 17.8793 93.5781 18.2644C94.9983 18.6612 96.4362 18.5504 97.6501 17.7217C98.4574 17.1732 98.9407 17.1849 99.5948 17.891C100.019 18.3519 100.638 18.6262 101.174 18.988C101.115 19.2097 101.05 19.4256 100.991 19.6415ZM96.831 12.1666C96.8723 10.4218 95.9883 9.54067 94.2735 9.54651C92.6706 9.54651 91.5097 10.6669 91.5745 12.1666C93.3306 12.1666 95.0808 12.1666 96.831 12.1666Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M129.501 21.8183C126.172 21.8591 123.502 20.6337 122.218 17.506C120.962 14.4483 121.122 11.4023 123.443 8.76474C126.072 5.78291 132.1 5.5495 135.035 8.27457C135.553 8.75307 135.665 9.16154 135.058 9.64586C134.746 9.89095 134.445 10.1769 134.192 10.4803C133.532 11.2797 132.972 11.4956 132.012 10.7079C130.597 9.54083 128.01 9.80925 126.891 11.023C125.465 12.5752 125.417 15.5337 126.796 17.0975C127.916 18.3638 130.45 18.7081 131.894 17.5352C133.013 16.6307 133.544 17.0217 134.345 17.8678C135.83 19.4258 135.913 19.7176 133.992 20.6687C132.624 21.3456 131.08 21.6665 129.613 22.145C129.578 22.0283 129.537 21.9233 129.501 21.8183Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2684 14.5591C78.8106 13.3511 79.2761 12.3183 79.7358 11.2796C80.2838 10.0367 80.8672 8.8113 81.3386 7.54504C81.6156 6.80396 82.0752 6.58222 82.8001 6.60556C83.5661 6.6289 84.3381 6.63474 85.1042 6.6114C85.9763 6.58806 86.1944 6.89733 85.8172 7.69676C84.4854 10.5094 83.1831 13.3278 81.869 16.1462C81.1265 17.7334 80.331 19.3031 79.6474 20.9195C79.3115 21.7189 78.7517 21.8065 78.015 21.8123C77.3079 21.8181 76.8482 21.6839 76.5124 20.9429C74.55 16.5781 72.5111 12.2483 70.5193 7.89516C70.0243 6.8098 70.1598 6.73977 71.303 6.59389C73.6131 6.29629 75.2041 6.83897 75.8582 9.33647C76.2707 10.8945 77.1252 12.3416 77.7911 13.8355C77.8677 14.028 78.0268 14.1973 78.2684 14.5591Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M159.396 8.98056C160.521 7.46339 161.759 6.52391 163.515 6.41887C164.281 6.37219 164.688 6.59976 164.629 7.40503C164.617 7.56259 164.623 7.72597 164.623 7.88353C164.641 10.3985 164.641 10.3985 162.219 10.9821C160.504 11.3964 159.437 12.7268 159.349 14.7925C159.266 16.6598 159.272 18.5387 159.325 20.4119C159.355 21.3338 159.084 21.7073 158.111 21.6898C154.469 21.6314 155.124 22.0399 155.094 18.848C155.065 15.1835 155.112 11.5131 155.07 7.84851C155.059 6.87402 155.347 6.40136 156.385 6.56475C156.544 6.58809 156.709 6.57642 156.868 6.58226C159.148 6.61144 159.148 6.61143 159.396 8.98056Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3822 9.08554C57.4724 7.49251 58.7571 6.57637 60.5485 6.45966C61.3146 6.40715 61.6269 6.64056 61.6564 7.44583C61.7565 10.346 61.7742 10.3168 58.9574 10.9995C57.6197 11.3263 56.7358 12.3066 56.5885 13.5845C56.341 15.7494 56.2703 17.9435 56.2879 20.1259C56.2997 21.3221 55.9933 21.6956 54.7322 21.6489C51.6443 21.538 52.0981 21.8648 52.0863 19.0114C52.0745 15.3468 52.1334 11.6822 52.0627 8.01768C52.0392 6.87397 52.4458 6.48884 53.5242 6.62305C53.5654 6.62889 53.6067 6.62305 53.6479 6.62305C56.0581 6.60555 56.0581 6.60555 56.3822 9.08554Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7601 14.0629C63.7601 11.9914 63.7955 9.91986 63.7425 7.84834C63.7189 6.90302 64.0725 6.58208 65.0153 6.60542C68.5334 6.67545 67.9382 6.19112 67.9736 9.49972C68.0089 13.0826 67.95 16.6713 68.0089 20.2541C68.0266 21.2987 67.6848 21.6488 66.6241 21.6313C63.2946 21.5613 63.7837 21.9172 63.766 18.842C63.7484 17.249 63.7601 15.6559 63.7601 14.0629Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3389 2.37496C68.3271 3.84545 67.4255 4.6974 65.8757 4.6974C64.3848 4.6974 63.3299 3.66456 63.3771 2.24075C63.4183 0.881128 64.4378 0 65.964 0C67.5021 0.0116706 68.3507 0.857787 68.3389 2.37496Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0482 5.10007C10.0287 3.5829 9.12711 2.2933 8.3139 0.957021C8.2255 0.816974 8.63211 0.128411 8.82658 0.11674C10.3057 0.0467167 11.7966 0.0408814 13.2757 0.0992343C13.8886 0.122575 14.1184 0.519375 13.7354 1.09123C12.9045 2.34582 12.0677 3.58873 11.0482 5.10007Z",
    fill: "white"
  })));
};
var lang$1 = _defineProperty({}, EN_GB, {
  footerAriaLabel: 'DriveScore',
  address: {
    title: 'ADDRESS',
    body: 'Vox Studios, VG 203, 1-45 Durham Street, Vauxhall, SE11 5JH'
  },
  body: ['Made with <0>❤</0> by ClearScore.', 'Registered in England and Wales (No. 09221862).', 'Authorised and Regulated by the Financial Conduct Authority (FRN: 654446).', 'ICO ZA100119. VAT registration number 255 8953 58.'],
  copyright: '© ClearScore Technology Ltd. All Rights Reserved.',
  logoTitle: 'DriveScore logo',
  privacyCta: 'Privacy and Cookie Policy',
  termsCta: 'Terms and Conditions',
  termsUrl: 'https://www.clearscore.com/drive-score-terms'
});
var Heart = function Heart(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React__default.createElement("span", {
    className: styles$1.heart
  }, children);
};
var Footer = function Footer(_ref3) {
  var privacyUrl = _ref3.privacyUrl;
  var _useLanguage = useLanguage(lang$1),
    address = _useLanguage.address,
    body = _useLanguage.body,
    copyright = _useLanguage.copyright,
    privacyCta = _useLanguage.privacyCta,
    termsCta = _useLanguage.termsCta,
    termsUrl = _useLanguage.termsUrl,
    logoTitle = _useLanguage.logoTitle,
    footerAriaLabel = _useLanguage.footerAriaLabel;
  return /*#__PURE__*/React__default.createElement("footer", {
    className: styles$1.footerSection,
    "aria-label": footerAriaLabel
  }, /*#__PURE__*/React__default.createElement(SvgDsLogo, {
    className: styles$1.dsLogo,
    role: "img",
    title: logoTitle
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$1.bodyWrapper
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$1.body
  }, body.map(function (line) {
    return /*#__PURE__*/React__default.createElement(Text.Body2, {
      key: line
    }, interpolateWithComponents(line, [{
      Component: Heart
    }]));
  })), /*#__PURE__*/React__default.createElement("div", {
    className: styles$1.address
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$1.addressTitle
  }, address.title), /*#__PURE__*/React__default.createElement(Text.Body2, null, address.body))), /*#__PURE__*/React__default.createElement("div", {
    className: styles$1.links
  }, /*#__PURE__*/React__default.createElement(Text.Link, {
    href: privacyUrl,
    theme: Text.Theme.LIGHT,
    target: "_blank"
  }, /*#__PURE__*/React__default.createElement(Text.Button, null, privacyCta)), /*#__PURE__*/React__default.createElement(Text.Link, {
    href: termsUrl,
    theme: Text.Theme.LIGHT,
    target: "_blank"
  }, /*#__PURE__*/React__default.createElement(Text.Button, null, termsCta))), /*#__PURE__*/React__default.createElement("div", {
    className: styles$1.copyright
  }, /*#__PURE__*/React__default.createElement(Text.Caption, null, copyright)));
};
var lang = _defineProperty({}, EN_GB, {
  navAriaLabel: 'DriveScore',
  logoTitle: 'drivescore logo',
  burgerIconTitle: 'navigation menu',
  homeCta: 'Home',
  partnerCta: 'Partner with us',
  helpCta: 'Help',
  loginCta: 'Login'
});
var styles = {
  "navbar": "navbar--qnqNQ",
  "logoLink": "logoLink--pQgxe",
  "logoStatic": "logoStatic--wBe37",
  "logo": "logo--0YveJ",
  "displayLinks": "displayLinks--6pBzq",
  "displayBurgerMenu": "displayBurgerMenu--6h-8T",
  "burgerButton": "burgerButton--4zzk6",
  "burgerIcon": "burgerIcon--5zF2M",
  "drawerContent": "drawerContent--hZUrQ",
  "link": "link--vvAwA",
  "selected": "selected--uvdbS",
  "burgerMenu": "burgerMenu--jBwEq"
};
var marketConfig = _defineProperty({}, GB, {
  links: [{
    cta: lang[EN_GB].homeCta,
    href: '/'
  }, {
    cta: lang[EN_GB].partnerCta,
    href: '/partner-with-us/'
  }, {
    cta: lang[EN_GB].helpCta,
    href: '//help.drivescore.com'
  }, {
    cta: lang[EN_GB].loginCta,
    href: '//app.drivescore.com'
  }]
});
var navLinks = function navLinks(_ref4) {
  var links = _ref4.links,
    isBurgerMenu = _ref4.isBurgerMenu,
    currentPath = _ref4.currentPath;
  return links.map(function (_ref5) {
    var _cx;
    var href = _ref5.href,
      cta = _ref5.cta;
    var isCSDomain = currentPath && currentPath.startsWith('/drivescore');
    var path = isCSDomain && !href.startsWith('//') ? "/drivescore".concat(href) : href;
    return /*#__PURE__*/React__default.createElement("a", {
      key: "".concat(cta).concat(path),
      className: cx(styles.link, (_cx = {}, _defineProperty(_cx, styles.selected, currentPath === path), _defineProperty(_cx, styles.burgerMenu, isBurgerMenu), _cx)),
      href: path
    }, cta);
  });
};
var NavigationBar = function NavigationBar() {
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    currentPath = _useState2[0],
    setCurrentPath = _useState2[1];
  var isBurgerMenuRendered = useMedia([null, mediaQuery['ds-mq-medium']], [true, false]);
  var _useLanguage2 = useLanguage(lang),
    logoTitle = _useLanguage2.logoTitle,
    navAriaLabel = _useLanguage2.navAriaLabel,
    burgerIconTitle = _useLanguage2.burgerIconTitle;
  var links = marketConfig[GB].links;
  var pathname = window.location.pathname;
  var isOpenOverride = !isBurgerMenuRendered ? isBurgerMenuRendered : null;
  var logoHref = currentPath && currentPath.startsWith('/drivescore') ? '/drivescore/' : '/';
  useEffect(function () {
    setCurrentPath(pathname);
  }, [pathname]);
  return /*#__PURE__*/React__default.createElement("nav", {
    className: styles.navbar,
    "aria-label": navAriaLabel
  }, /*#__PURE__*/React__default.createElement("a", {
    className: styles.logoLink,
    href: logoHref
  }, /*#__PURE__*/React__default.createElement(SvgDsLogo, {
    className: styles.logo,
    role: "img",
    title: logoTitle
  })), /*#__PURE__*/React__default.createElement("div", {
    className: styles.logoStatic
  }, /*#__PURE__*/React__default.createElement(SvgDsLogo, {
    "aria-hidden": true,
    className: styles.logo,
    role: "img",
    title: logoTitle
  })), /*#__PURE__*/React__default.createElement("div", {
    className: styles.displayLinks
  }, navLinks({
    links: links,
    currentPath: currentPath
  })), /*#__PURE__*/React__default.createElement("div", {
    className: styles.displayBurgerMenu
  }, canUseDom() && /*#__PURE__*/React__default.createElement(Drawer, {
    isOpenOverride: isOpenOverride,
    theme: Drawer.Theme.DARK
  }, /*#__PURE__*/React__default.createElement(Drawer.Toggle, {
    asChild: true
  }, /*#__PURE__*/React__default.createElement(BurgerIcon, {
    className: styles.burgerIcon,
    role: "img",
    title: burgerIconTitle
  })), /*#__PURE__*/React__default.createElement(Drawer.Content, null, /*#__PURE__*/React__default.createElement("div", {
    className: styles.drawerContent
  }, navLinks({
    links: links,
    isBurgerMenu: true,
    currentPath: currentPath
  }))))));
};
export { Footer, NavigationBar };